import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'leaveToRemains'>;

type Params = Fields;

export function getPageStatus({ leaveToRemains }: Params): { complete: boolean } {
  let complete = false;
  if (!leaveToRemains || leaveToRemains.length === 0) {
    complete = false;
  } else {
    complete = !leaveToRemains.some(leave => {
      return leave.applicationDate === '' || leave.applicationType === '' || leave.reference === '';
    });
  }

  return { complete };
}
